import React from 'react';

import CreateStoryDialog from '../CreateStoryDialog';

import { PlusIcon } from "@heroicons/react/solid";
import Button from "UI/Button";

export default class CreateStoryButton extends React.Component
{
    state = {
        show: false,
    };

    handleClickShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render()
    {
        return <>
            <Button className='space-x-2' type="primary" onClick={this.handleClickShow}>
                <PlusIcon className='w-5' />
                <span>Create a new story</span>
            </Button>

            { this.renderCreateStoryDialog() }
        </>
    }

    renderCreateStoryDialog()
    {
        return <CreateStoryDialog
            open={this.state.show}
            onClose={this.handleClose}
        />;
    }
}
